<script>
    import { OnClickAttribute, OnClickMaster, OnClickFreeSkill } from '../../../script/handle/play'
    
    export let Position, Monster, Section, Skills, DataCheck
</script>

<div class='skills'>
    {#if Skills.length > 0}
        {#each Skills as skill, i}
            <div class="skill">
                {#if skill.num > 0}
                    <div class="left">
                        <img
                            src="../img/monsters/{Monster}/{Section}_{(skill.num)}.png"
                            alt="{Monster}"
                        >
                    </div>

                    <div class="right">
                        <div class="name">{skill.name}</div>

                        <div class="row">
                            <div class="tag">특성</div>
                            
                            <div class="list">
                                {#each skill.attribute as attribute, j}
                                    <div
                                        class="attribute"
                                        class:free={attribute == ''}
                                        on:click={() => OnClickAttribute(Position, Section, i, j)}
                                    >
                                        {#if attribute != ''}
                                            {#if DataCheck == 1}
                                                {attribute.detail}
                                            {:else}
                                                {attribute}
                                            {/if}
                                        {:else}
                                            <div class="free">자유 선택</div>
                                        {/if}
                                    </div>
                                {/each}
                            </div>
                        </div>

                        {#if Section == 0}
                            <div class="row">
                                <div class="tag">마스터</div>

                                <div
                                    class="master"
                                    class:free={skill.master.name == ''}
                                    on:click={() => OnClickMaster(Position, Section, i)}
                                >
                                    {#if skill.master.name != ''}
                                        {skill.master.name} : {skill.master.detail}
                                    {:else}
                                        자유 선택
                                    {/if}
                                </div>
                            </div>
                        {/if}
                    </div>
                {:else}
                    <div
                        class="freeSkill"
                        on:click={() => OnClickFreeSkill(Position, Section, i)}
                    >
                        자유 선택
                    </div>
                {/if}
            </div>

            {#if Skills.length > (i+1)}
                <hr>
            {/if}
        {/each}
    {:else}
        추천 스킬을 모두 찍으셨습니다.
    {/if}
</div>

<style lang="scss">
    .skills {
        width: calc(100% - 10px);
        height: fit-content;
        padding: 5px;

        .skill {
            width: calc(100%);
            height: fit-content;
            margin: 20px 0px;
            display: inline-flex;
            gap: 30px;

            .left {
                width: calc(20%);
                vertical-align: top;

                @include mobile { display: none; }
                @include tablet { display: none; }
            }

            .right {
                width: calc(80% - 30px);
                vertical-align: top;

                .name {
                    margin-bottom: 20px;
                    font-family: aggro;
                    font-size: 20px;
                    font-weight: 400;
                    letter-spacing: -0.6px;
                }

                .row {
                    margin-bottom: 20px;

                    .tag {
                        font-size: 15px;
                        font-weight: 900;
                        margin-bottom: 10px;
                    }

                        .attribute, .master {
                            padding: 5px 10px;
                            justify-content: center;
                            align-items: center;
                            border-radius: 5px;
                            border: 1px solid $cl3;

                            font-size: 15px;
                            font-weight: 400;

                            &:hover {
                                background: $cl3;
                                cursor: pointer;
                            }

                            .free {
                                color: $cl4;
                            }
                        }

                        .attribute {
                            width: fit-content;
                            margin: 0px 6px 6px 0px;
                            display: inline-block;
                        }

                        .master {
                            width: calc(100% - 20px - 2px);
                            
                            /* 단어 단위로 자르기 */
                            word-break: keep-all;
                        }
                }

                @include mobile {  width: calc(100% - 30px); }
                @include tablet {  width: calc(100% - 30px); }
            }

            .freeSkill {
                width: calc(100% - 10px - 10px);
                margin: 5px;
                padding: 5px;
                border: 2px solid $cl3;
                border-radius: $br1;
                color: $cl4;
                font-size: 20px;
                text-align: center;
                list-style: none;
                /* 단어 단위로 자르기 */
                word-break: keep-all;
                display: inline-block;
                cursor: pointer;

                &:hover { background: $cl3; }
            }
        }

        hr {
            border: 1px solid $cl6;
        }
    }
</style>